import React from 'react';

import { SectionWidgetConfig, useSectionWidgetConfig } from '@neptune/shared/widgets-domain';

type SharedConfig = SectionWidgetConfig;

type ReturnParams = {
  sharedConfig: SharedConfig;
  updateSharedConfig: (config: SharedConfig) => void;
  hasSharedConfig: boolean;
};

export const useSharedWidgetConfig = ({ widgetId }: { widgetId?: string }): ReturnParams => {
  const { getParentSectionConfig, updateParentSectionConfig } = useSectionWidgetConfig();

  const sharedConfig = React.useMemo(() => {
    const resolvedConfig = widgetId ? getParentSectionConfig(widgetId) : undefined;

    return resolvedConfig ?? { sharedStep: undefined };
  }, [getParentSectionConfig, widgetId]);

  const updateSharedConfig = React.useCallback(
    (config: SharedConfig) => {
      if (widgetId) {
        updateParentSectionConfig(widgetId, config);
      }
    },
    [updateParentSectionConfig, widgetId],
  );

  return {
    sharedConfig,
    updateSharedConfig,
    hasSharedConfig: !!widgetId && !!getParentSectionConfig(widgetId),
  };
};
